/* (SYNC) */
export const RESET_DYNAMIC_LIST = 'RESET_DYNAMIC_LIST';
export const SET_DYNAMIC_LIST = 'SET_DYNAMIC_LIST';
export const RESET_DYNAMIC_LIST_ITEM = 'RESET_DYNAMIC_LIST_ITEM';
export const SET_DYNAMIC_LIST_ITEM = 'SET_DYNAMIC_LIST_ITEM';

/* (ASYNC) */
export const FETCH_DYNAMIC_LIST_INIT = 'FETCH_DYNAMIC_LIST_INIT';
export const FETCH_DYNAMIC_LIST_SUCCESS = 'FETCH_DYNAMIC_LIST_SUCCESS';
export const FETCH_DYNAMIC_LIST_FAILURE = 'FETCH_DYNAMIC_LIST_FAILURE';
export const FETCH_DYNAMIC_LIST_INIT_ITEM = 'FETCH_DYNAMIC_LIST_INIT_ITEM';
export const FETCH_DYNAMIC_LIST_SUCCESS_ITEM = 'FETCH_DYNAMIC_LIST_SUCCESS_ITEM';
export const FETCH_DYNAMIC_LIST_FAILURE_ITEM = 'FETCH_DYNAMIC_LIST_FAILURE_ITEM';
export const FETCH_DYNAMIC_LIST_DELETE_INIT = 'FETCH_DYNAMIC_LIST_DELETE_INIT';
export const FETCH_DYNAMIC_LIST_DELETE_SUCCESS = 'FETCH_DYNAMIC_LIST_DELETE_SUCCESS';
export const FETCH_DYNAMIC_LIST_DELETE_FAILURE = 'FETCH_DYNAMIC_LIST_DELETE_FAILURE';
export const FETCH_DYNAMIC_LIST_ALL_INIT = 'FETCH_DYNAMIC_LIST_ALL_INIT';
export const FETCH_DYNAMIC_LIST_ALL_SUCCESS = 'FETCH_DYNAMIC_LIST_ALL_SUCCESS';
export const FETCH_DYNAMIC_LIST_ALL_FAILURE = 'FETCH_DYNAMIC_LIST_ALL_FAILURE';
export const FETCH_LIST_CONCAT = 'FETCH_LIST_CONCAT';
export const DELETE_LIST_FROM_STORE = 'DELETE_LIST_FROM_STORE';
export const FETCH_DYNAMIC_ITEM_ALL_INIT = 'FETCH_DYNAMIC_ITEM_ALL_INIT';
export const FETCH_DYNAMIC_ITEM_ALL_SUCCESS = 'FETCH_DYNAMIC_ITEM_ALL_SUCCESS';
export const FETCH_DYNAMIC_ITEM_ALL_FAILURE = 'FETCH_DYNAMIC_ITEM_ALL_FAILURE';
export const RESET_ITEMS = 'RESET_ITEMS';
export const CONCAT_ITEMS = 'CONCAT_ITEMS';
export const EDIT_ITEM_INIT = 'EDIT_ITEM_INIT';
export const EDIT_ITEM_FAILURE = 'EDIT_ITEM_FAILURE';
export const EDIT_ITEM_SUCCESS = 'EDIT_ITEM_SUCCESS';

export const EDIT_ITEMS_INIT = 'EDIT_ITEM_INIT';
export const EDIT_ITEMS_FAILURE = 'EDIT_ITEM_FAILURE';
export const EDIT_ITEMS_SUCCES = 'EDIT_ITEM_SUCCES';

export const DELETE_ITEM_INIT = 'DELETE_ITEM_INIT';
export const DELETE_ITEM_FAILURE = 'DELETE_ITEM_FAILURE';
export const DELETE_ITEM_SUCCES = 'DELETE_ITEM_SUCCES';
export const DELETE_ITEM = 'DELETE_ITEM';
export const DELETE_ITEM_ONCE = 'DELETE_ITEM_ONCE';



// WEBPACK FOOTER //
// ./source/client/actions/dynamic_list/types.js